import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';

import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import DeleteIcon from '@mui/icons-material/Delete';
import AlarmIcon from '@mui/icons-material/Alarm';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import HomeMaxIcon from '@mui/icons-material/HomeMax';
import SettingsIcon from '@mui/icons-material/Settings';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import ContactlessIcon from '@mui/icons-material/Contactless';
import ContactsIcon from '@mui/icons-material/Contacts';
import { useHistory } from "react-router-dom";


export default function TemporaryDrawer() {
    const history = useHistory();

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const options = ['Inicio', 'Como Funciona', 'Pasos a seguir', 'Dapp','Contacto'];

  function handleClick(event){
      console.log(event.target.textContent,"menu");
      const menu = event.target.textContent;
      if( menu == options[0]){
          homeClick();
      }
      if( menu == options[1]){
        howClick();
    }
    if( menu == options[2]){
        stepClick();
    }
    if( menu == options[3]){
        DappClick();
    }
    if( menu == options[4]){
        ContactClick();
    }
  }

  function homeClick() {
    history.push("/");
  }


  function howClick() {
    history.push("/HowWorks");
  }



  function stepClick() {
    history.push("/StepsToFollow");
  }



  function DappClick() {
    history.push("/auth");
  }

  function ContactClick(){
      history.push("/Contact");
  }

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {options.map((text, index) => (
          <ListItem  color="secondary"  button key={text}>
            <ListItemIcon  color="secondary" >
              {index  === 0 ? <HomeMaxIcon /> :  <div></div> }
              {index  === 1 ? <SettingsIcon /> :  <div></div> }
              {index  === 2 ? <LibraryBooksIcon /> :  <div></div> }
              {index  === 3 ? <ContactlessIcon /> :  <div></div> }
              {index  === 4 ? <ContactsIcon /> :  <div></div> }
            </ListItemIcon>
         


            <ListItemText onClick={(e) => handleClick(e)} className="home__menu-item" primary={text} />
            
          </ListItem>
        ))}
      </List>
      <Divider />
      
    </Box>
  );

  return (
    <div>
      
        <React.Fragment key={'top'}>

<IconButton onClick={toggleDrawer('top', true)} color="secondary" aria-label="add an alarm">
  <MenuTwoToneIcon />
</IconButton>
           <Drawer
            anchor={'top'}
            color="secondary" 
            open={state['top']}
            onClose={toggleDrawer('top', false)}
          >
            {list('top')}
          </Drawer>
        </React.Fragment>
      
    </div>
  );
}
